/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VocabWidget_exercise = {
    readonly content: {
        readonly terms: ReadonlyArray<{
            readonly word: string;
            readonly definition: string | null;
            readonly image: {
                readonly id: string;
                readonly url: string;
            } | null;
        }>;
    };
    readonly " $refType": "VocabWidget_exercise";
};
export type VocabWidget_exercise$data = VocabWidget_exercise;
export type VocabWidget_exercise$key = {
    readonly " $data"?: VocabWidget_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"VocabWidget_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "VocabWidget_exercise",
  "type": "VocabExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "VocabExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "terms",
          "storageKey": null,
          "args": null,
          "concreteType": "VocabExerciseTerm",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "word",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "definition",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "image",
              "storageKey": null,
              "args": null,
              "concreteType": "Image",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "url",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": "LARGE_SQUARE"
                    }
                  ],
                  "storageKey": "url(size:\"LARGE_SQUARE\")"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '13149635870bcd30a86dbf8344fd3f68';
export default node;
